import React, { useMemo } from "react";

import { SingleSelectInput } from "@performyard/py-components";

import { useGroups } from "../../../api/hooks";

import type { Group } from "../../../api/services/defs/groups";

export type { Group } from "../../../api/services/defs/groups";

type GroupSelectProps = {
	value?: Group;
	onChange: (value: Group | null) => void;
	placeholder?: string;
	isClearable?: boolean;
	disabled?: boolean;
};

const GroupSelect = ({
	value,
	onChange,
	placeholder = "Make a selection",
	isClearable = false,
	disabled = false,
}: GroupSelectProps) => {
	const { data: groups, isLoading } = useGroups();

	const selectOptions = useMemo(
		() =>
			(groups ?? []).map((group) => ({
				label: group.name,
				value: group,
			})),
		[groups]
	);

	return (
		<SingleSelectInput<Group>
			options={selectOptions}
			value={value}
			onChange={onChange}
			placeholder={isLoading ? "Loading..." : placeholder}
			isClearable={isClearable}
			disabled={disabled || isLoading}
			selectionVariant="combobox"
		/>
	);
};

export default GroupSelect;
